export function BaseIcon({ children, color, size, style = {}, width, height, ...props }) {
  const computedSize = size || '1em';

  const baseStyle = {};
  const styleProp = {
    verticalAlign: 'middle',
    ...baseStyle,
    ...style,
  };

  const computedColor = color || style.color || baseStyle.color;
  if (computedColor) {
    styleProp.color = computedColor;
  }

  return (
    <svg
      fill="currentColor"
      preserveAspectRatio="xMidYMid meet"
      height={height || computedSize}
      width={width || computedSize}
      {...props}
      style={styleProp}
    >
      {children}
    </svg>
  );
}
